/** Default categories when account settings are unavailable or empty. */
export const DEFAULT_ACCOUNT_CATEGORIES = [
  'Sales & GTM',
  'Marketing & Content',
  'Customer Success & Support',
  'Operations',
  'Product & Design',
  'Engineering & IT',
  'Data & Analytics',
  'Finance & Legal',
  'People & HR',
  'Strategy & Planning',
  'Research & Learning',
  'Compliance & Risk',
  'Other',
];

export function resolveAccountCategoryOptions(accountCategories) {
  const list = (accountCategories || [])
    .map((c) => String(c || '').trim())
    .filter(Boolean);
  return list.length > 0 ? list : [...DEFAULT_ACCOUNT_CATEGORIES];
}

export function isPresetCategory(value, options) {
  const normalized = String(value || '').trim();
  return (options || []).includes(normalized);
}

/** Map stored category to a builder chip; unknown values fall back to Other. */
export function resolveCategoryChip(category, options) {
  const normalized = String(category || '').trim();
  if (normalized === 'Projects') return 'Collections';
  if (!normalized || isPresetCategory(normalized, options)) {
    return normalized || '';
  }
  return 'Other';
}
